<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Quiz </span>
        </v-row>
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="loader" absolute>
            Loading
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span>
                    <h3>Quiz</h3>
                </span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="3">
                        <v-select label="Academic Year" variant="outlined" :items="aylist" v-model="ay" item-value="ay"
                            item-text="ay" required="true" :rules="[v => !!v || 'Required']"></v-select>
                    </v-col>
                    <v-col cols="12" sm="3">
                        <v-select label="Semester" variant="outlined" :items="semlist" v-model="sem" item-value="sem"
                            item-text="sem" required="true" :rules="[v => !!v || 'Required']"></v-select>
                    </v-col>
                    <v-col cols="12" sm="3" style="padding:25px;">
                        <v-btn :loading="dialog" class="button" @click="proceed()">
                            Fetch
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <br />
        <div v-if="displaytable">
            <v-card class="card">
                <v-card-text v-if="erpcourseofferinginstructorlist.length!=0">
                    <v-simple-table>
                        <thead>
                            <tr color="green">
                                <th>S.No.</th>
                                <th>Course Name</th>
                                <th>Program</th>
                                <th>Year</th>
                                <th>Division</th>
                                <th>Total Studnt</th>
                                <th>Question Bank</th>
                                <th>Proctor</th>
                                <th>Quiz Dashboard</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in erpcourseofferinginstructorlist" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{item.course_name}}</td>
                                <td>{{item.program}}</td>
                                <td>{{item.year}}</td>
                                <td>{{item.division}}</td>
                                <td v-if="item.totalstudent!=0">{{item.totalstudent}}</td>
                                <td style="font-size:18px;padding:5px;color:purple;" v-else>Subject Registration Not
                                    Done.</td>
                                <td v-if="item.questioncount!=0">{{item.questioncount}}</td>
                                <td style="font-size:18px;padding:5px;color:red;" v-else>Questions Not Added.</td>
                                <td>
                                    <!-- <span class="mt-3">
                                        <v-select placeholder="Select Proctor" class="select"
                                            @change="changePorctor(item.id,item.course_id,item.inst)"
                                            :items="proctorlist" outlined dense item-text="name" item-value="id"
                                            v-model="item.inst" persistent-hint></v-select>
                                    </span> -->
                                    <v-select v-model="item.inst" :items="filteredProctors" item-text="name"
                                        item-value="id" outlined dense placeholder="Select Proctor" persistent-hint
                                        clearable :menu-props="{ closeOnContentClick: false }"
                                        @change="changePorctor(item.id, item.course_id, item.inst)">
                                        <!-- Search Box Inside the Dropdown -->
                                        <template v-slot:prepend-item>
                                            <v-text-field v-model="search" placeholder="Search..." clearable outlined
                                                dense autofocus></v-text-field>
                                        </template>
                                    </v-select>

                                </td>
                                <td>
                                    <center>
                                        <v-btn class="button" @click="proceedToCreateQuiz(item.id,item.course_id)">
                                            Quiz Dashboard
                                        </v-btn>
                                    </center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import { VueMathjax } from "vue-mathjax";
    import MathLive from "mathlive";
    import loader from "sass-loader";
    export default {
        components: {
            "vue-mathjax": VueMathjax,
        },
        data: () => ({
            aylist: [],
            semlist: [],
            ay: null,
            sem: null,
            snackbar_msg: "",
            loader: false,
            displaytable: false,
            erpcourseofferinginstructorlist: [],
            dialog: false,
            proctorlist: [],
            proctorinstructor: null,
            search: "", // Search box input
        }),
        mounted() {
            this.init();
        },
        computed: {
            // Filters the proctor list without changing existing logic
            filteredProctors() {
                if (!this.search) return this.proctorlist;
                return this.proctorlist.filter(proctor =>
                    proctor.name.toLowerCase().includes(this.search.toLowerCase())
                );
            }
        },
        methods: {
            init() {
                this.dialog = true;
                axios
                    .post("QuizDashboard/quizAySemFilter")
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.aylist = res.data.aylist;
                            this.semlist = res.data.semlist;
                            this.ay = res.data.ay;
                            this.sem = res.data.sem;
                            this.displaytable = false;
                            this.dialog = false;
                        } else {
                            this.showSnackbar(res.data.msg, "#b71c1c");
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("Something Went Wrong...", "#b71c1c");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            proceed() {
                const data = {
                    ay: this.ay,
                    sem: this.sem,
                };
                this.dialog = true;
                axios
                    .post("QuizDashboard/displayBatchToInstructorForQuiz", data)
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.erpcourseofferinginstructorlist = res.data.erpcourseofferinginstructorlist;
                            this.proctorlist = res.data.proctorlist;
                            this.displaytable = true;
                            this.dialog = false;
                        } else {
                            this.showSnackbar(res.data.msg, "#b71c1c");
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("Something Went Wrong...", "#b71c1c");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            proceedToCreateQuiz(erpcourseofferinginstructorid, course_id) {
                this.$router.push({ name: "quiz-dashboard", params: { erpcourseofferinginstructorid: erpcourseofferinginstructorid, course_id: course_id } });
                window.open(routeData.href, '_blank');
            },

            changePorctor(id, course, instructor) {
                const data = {
                    id: id,
                    course: course,
                    instructor: instructor
                };
                this.dialog = true;
                axios
                    .post("QuizDashboard/changeProctor", data)
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.showSnackbar("green", res.data.msg,);
                        } else {
                            this.showSnackbar(res.data.msg, "#b71c1c");
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("Something Went Wrong...", "#b71c1c");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    thead {
        background-color: hsla(190, 99%, 30%, 1) !important;
        white-space: nowrap !important;
    }

    th {
        color: #ffffff !important;
    }

    .span-mr {
        margin: 0rem !important;
        padding: 0px;
        padding-top: 0.5rem;
    }

    .card {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
    }

    .button {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
        color: rgb(1, 127, 152);
        background: transparent !important;
        border-radius: 50px;
    }
</style>